export default "__VITE_ASSET__BHgqXqhr__"